import { useTypedSelector } from 'state';
import { useEffect } from 'react';

interface UserLoggedInProps {
  handler: (spotId: string) => void;
}

export function UserLoggedIn(props: UserLoggedInProps) {
  const { handler } = props;

  const user = useTypedSelector(state => state.currentUser);
  const spotId = useTypedSelector(state => state.application.spotId);

  useEffect(() => {
    if (spotId && user && user.isRegistered) {
      handler(spotId);
    }
  }, [handler, user, spotId]);

  return null;
}
